<template>
  <div class="add-step" style="overflow: scroll">
    <div class="bg-black add-accont-header">
      <div class="add-brd">
        <div class="h-back" @click="goBackHandler">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </div>
        <h2>اطلاعات فضای مجازی</h2>
        <p>مرحله پایانی</p>
      </div>
      <div>
        <svg class="header-progresbar2">
          <circle class="meter" cx="57" cy="57" r="42" />
          <circle class="meter-2" cx="57" cy="57" r="42" />
          <text class="SVG-text" x="37" y="47">مرحله</text>
          <text x="65" y="74" class="SVG-text">3</text>
          <text x="50" y="74" class="SVG-text">از</text>
          <text x="37" y="74" class="SVG-text">3</text>
        </svg>
      </div>
    </div>
    <div class="add-card">
      <p class="head-step2">
        اطلاعات فضای مجازی کسب و کار خود را در صورت وجود وارد کنید
      </p>
      <div class="gruop">
        <p>توییتر</p>
        <input v-model="model.twitter" class="inputName" placeholder="توییتر" />
      </div>
      <div class="gruop">
        <p>اینستاگرام</p>
        <input
          v-model="model.instagram"
          class="inputName"
          placeholder="اینستاگرام"
        />
      </div>
      <div class="gruop">
        <p>توییتر</p>
        <input
          v-model="model.telegram"
          class="inputName"
          placeholder="توییتر"
        />
      </div>
      <div class="gruop">
        <p>وب سایت</p>
        <input
          v-model="model.website"
          class="inputName"
          placeholder="وب سایت"
        />
      </div>
      <div class="gruop">
        <p>ایمیل</p>
        <input v-model="model.email" class="inputName" placeholder="ایمیل" />
      </div>
      <button class="m-btn add-confer-btn" @click="creatAccountHandler">
        تایید
      </button>
    </div>
  </div>
</template>
<script>
export default {
  mounted() {
    this.model = this.$store.state.businessaccount.model;
  },
  data() {
    return {
      model: {},
    };
  },
  methods: {
    goBackHandler() {
      this.$router.back();
    },
    creatAccountHandler() {
      this.$store
        .dispatch("businessaccount/addAccount", this.model)
        .then(() => {
          this.$router.push({ name: "home" });
        });
    },
  },
};
</script>

<style scoped>
.head-step2 {
  margin-top: 50px;
  font-size: 20px;
}
</style>
